import React, { memo } from 'react'
import { Grid } from '@material-ui/core'
import { IMenuItem } from 'hooks/useMenu'
import { List } from 'immutable'
import { FooterList } from './FooterList'
import { useStyles } from './FooterListGroup.styles'

export interface IFooterListGroupProps {
  footerItems: List<IMenuItem>
}

export const FooterListGroup = memo(({ footerItems }: IFooterListGroupProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid className={classes.wrapper} container justifyContent="center" spacing={2}>
        {footerItems.map((footerItem, index) => (
          <FooterList key={`footer-item-${index}`} footerItem={footerItem} />
        ))}
      </Grid>
    </div>
  )
})
